import axios from 'axios';
import { getDeviceId } from '../utils/device-info.util';
import { getLocalValue } from '../utils/local-cache.util';
import { LS_ADMIN_USER_AUTH_TOKEN } from '../config/const.config';

const prepareRequestOptions = (
  url,
  method,
  data = null,
  contentType = false
) => {
  const baseAPIUrl = process.env.REACT_APP_CMS_API_ENDPOINT;
  const uuid = getDeviceId();
  const adminAuth = getLocalValue(LS_ADMIN_USER_AUTH_TOKEN);
  const options = {
    url: `${baseAPIUrl}${url}`,
    method,
    maxContentLength: Infinity,
    maxBodyLength: Infinity,
    headers: {
      'Content-Type': !contentType ? 'application/json' : 'multipart/form-data',
      'X-Req-Device': uuid,
      'X-Admin-Auth-Token': adminAuth,
    },
    data: !contentType ? JSON.stringify(data || {}) : data,
  };

  return options;
};

export const getDataList = async (type) => {
  const options = prepareRequestOptions(`/admin/list/${type}`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const getSearchListChannels = async () => {
  const options = prepareRequestOptions('/admin/channels/search-list', 'GET');

  const response = await axios(options);
  return response.data;
};

export const createNewCategory = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/category/create',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const viewCategoryById = async (id) => {
  const options = prepareRequestOptions(`/admin/category/${id}/view`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const updateCategoryById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/category/${id}/update`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const deleteCategoryById = async (id) => {
  const options = prepareRequestOptions(
    `/admin/category/${id}/delete`,
    'DELETE'
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListCategories = async () => {
  const options = prepareRequestOptions('/admin/categories/search-list', 'GET');

  const response = await axios(options);
  return response.data;
};

export const createNewShow = async (payload) => {
  const options = prepareRequestOptions('/admin/show/create', 'POST', payload);

  const response = await axios(options);
  return response.data;
};

export const viewShowById = async (id) => {
  const options = prepareRequestOptions(`/admin/show/${id}/view`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const updateShowById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/show/${id}/update`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const deleteShowById = async (id) => {
  const options = prepareRequestOptions(`/admin/show/${id}/delete`, 'DELETE');

  const response = await axios(options);
  return response.data;
};

export const getSearchListShows = async () => {
  const options = prepareRequestOptions('/admin/shows/search-list', 'GET');

  const response = await axios(options);
  return response.data;
};

export const assignCategoryToShow = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/show/${id}/category/assign`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const viewCategoryToShow = async (id) => {
  const options = prepareRequestOptions(
    `/admin/show/${id}/view/assigned-category`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const createNewVideo = async (payload) => {
  const options = prepareRequestOptions('/admin/video/create', 'POST', payload);

  const response = await axios(options);
  return response.data;
};

export const viewVideoById = async (id) => {
  const options = prepareRequestOptions(`/admin/video/${id}/view`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const updateVideoById = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/video/${id}/update`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const deleteVideoById = async (id) => {
  const options = prepareRequestOptions(`/admin/video/${id}/delete`, 'DELETE');

  const response = await axios(options);
  return response.data;
};

export const assignCategoryToVideo = async (id, payload) => {
  const options = prepareRequestOptions(
    `/admin/video/${id}/category/assign`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const getSearchListVideos = async () => {
  const options = prepareRequestOptions('/admin/videos/search-list', 'GET');

  const response = await axios(options);
  return response.data;
};

export const syncVideoCDNStatus = async (contentType) => {
  const options = prepareRequestOptions(
    `/admin/video/${contentType}/cdn/sync`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const getListSequence = async (query) => {
  const options = prepareRequestOptions(`/admin/sequence/list/${query}`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const updateChannelCategorySequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/sequence/category/update',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const updateChannelCategoryShowsSequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/sequence/show-category/update',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const updateChannelShowVideosSequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/sequence/video-show/update',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const updateChannelCategoryVideosSequence = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/sequence/video-category/update',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const getPageContentByType = async (type) => {
  const options = prepareRequestOptions(
    `/admin/web/content/view/${type}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const updatePageContentByType = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/web/content/update`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const getPlayableStream = async (uri) => {
  const options = prepareRequestOptions(
    `/admin/get/playable-stream?${uri}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const uploadAssetFile = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/upload/file/cdn`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const uploadVideoToBunnyCDN = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/upload/video/cdn`,
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const uploadImageToBunnyCDN = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/upload/image/cdn`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const uploadSrtToBunnyCDN = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/upload/srt/cdn`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const uploadBulkSrtToBunnyCDN = async (payload, bulkUpload = false) => {
  const options = prepareRequestOptions(
    `/admin/upload/srt/cdn?bulkUpload=${bulkUpload}`,
    'POST',
    payload,
    true
  );

  const response = await axios(options);
  return response.data;
};

export const deleteSrtToBunnyCDN = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/delete/srt/cdn`,
    'DELETE',
    payload
  );

  const response = await axios(options);
  return response.data;
};

export const viewCaptionsById = async (videoId) => {
  const options = prepareRequestOptions(
    `/admin/list/captions/${videoId}`,
    'GET'
  );

  const response = await axios(options);
  return response.data;
};

export const toggleStatus = async (payload) => {
  const options = prepareRequestOptions(
    `/admin/${payload.type}/status/toggle`,
    'POST',
    payload
  );
  const response = await axios(options);
  return response.data;
};

export const viewSettingsById = async (id) => {
  const options = prepareRequestOptions(`/admin/settings/${id}/view`, 'GET');

  const response = await axios(options);
  return response.data;
};

export const addUpdateSettings = async (payload) => {
  const options = prepareRequestOptions(
    '/admin/settings/addUpdate',
    'POST',
    payload
  );

  const response = await axios(options);
  return response.data;
};
